import { ApiResponse } from '@nohara-dxdev/oidc-core';
import {
  PaginatedQueryConfig,
  PaginationParams,
  PaginationResponse,
  usePaginatedQuery,
  UsePaginatedQueryOptions,
} from '@nohara-dxdev/react-core';
import { useScopeIds } from '@nohara-dxdev/react-oidc';

import { api } from '@/lib/api-client';
import { DashboardTaskGroupEntity } from '@/types/api';

export const getDashboardTaskGroups = async (
  orgId: string,
  projectId: string,
  params: PaginationParams,
): Promise<PaginationResponse<DashboardTaskGroupEntity>> => {
  const { data } = await api.get<
    undefined,
    ApiResponse<PaginationResponse<DashboardTaskGroupEntity>>
  >(`/orgs/${orgId}/projects/${projectId}/tasks/dashboard-groups`, {
    params,
  });

  return data;
};

export const getDashboardTaskGroupsQueryKey = (
  orgId: string | undefined | null,
  projectId: string | undefined | null,
) => {
  const queryKey: unknown[] = ['tasks', 'dashboard-groups'];
  if (orgId) queryKey.push('org', orgId);
  if (projectId) queryKey.push('project', projectId);
  return queryKey;
};

export const getDashboardTaskGroupsQueryOptions = (
  orgId: string | undefined | null,
  projectId: string | undefined | null,
): UsePaginatedQueryOptions<DashboardTaskGroupEntity> => {
  return {
    queryKey: getDashboardTaskGroupsQueryKey(orgId, projectId),
    queryFn: ({ pageParam }) =>
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      getDashboardTaskGroups(orgId!, projectId!, { ...pageParam }),
    enabled: !!orgId && !!projectId,
  };
};

interface UseDashboardTaskGroupsOptions {
  queryConfig?: PaginatedQueryConfig<typeof getDashboardTaskGroupsQueryOptions>;
}

// Dashboard-only (pages by group).
export const useDashboardTaskGroups = ({ queryConfig }: UseDashboardTaskGroupsOptions = {}) => {
  const { orgId, projectId } = useScopeIds();
  return usePaginatedQuery({
    ...getDashboardTaskGroupsQueryOptions(orgId, projectId),
    ...queryConfig,
  });
};
